import './Pagination.css';

const Pagination = ({ 
  itemsPerPage, 
  totalItems, 
  paginate, 
  currentPage,
  itemsPerPageOptions,
  handleItemsPerPageChange
}) => {
  const pageNumbers = [];
  
  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }
  
  return (
    <div className="pagination-container">
      <div className="pagination-controls">
        <button 
          onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)}
          disabled={currentPage === 1}
          className="pagination-button prev"
        >
          &laquo; Previous
        </button>
        
        <div className="page-numbers">
          {pageNumbers.map(number => (
            <button
              key={number}
              onClick={() => paginate(number)}
              className={`pagination-button ${currentPage === number ? 'active' : ''}`}
            >
              {number}
            </button>
          ))}
        </div>
        
        <button 
          onClick={() => paginate(currentPage < pageNumbers.length ? currentPage + 1 : pageNumbers.length)}
          disabled={currentPage === pageNumbers.length}
          className="pagination-button next"
        >
          Next &raquo;
        </button>
      </div>
      
      <div className="items-per-page">
        <span>Show:</span>
        <select 
          value={itemsPerPage}
          onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
        >
          {itemsPerPageOptions.map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <span>items per page</span>
      </div>
    </div>
  );
};

export default Pagination;
